<div p-3>
  <div class="scrollable-table">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="background-color: white;">
       <!-- Duyệt qua từng cột và tạo cột động -->
       <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
        <!-- Tiêu đề cột -->
        <th mat-header-cell *matHeaderCellDef> {{ column.title }} </th>
        <!-- Dữ liệu cột -->
        <td mat-cell *matCellDef="let element">
           <ng-container [ngSwitch]="column.type">
            <span *ngSwitchCase="'date'">{{ element[column.key] | date: 'dd/MM/yyyy' }}</span>
            <span *ngSwitchDefault>{{ element[column.key] }}</span>
          </ng-container>
        </td>
       
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <div style="display: flex; gap: 0px;">
            <ng-container *ngFor="let action of actions">
              <button
                mat-button
                [color]="action.color"
                *ngIf="action.isVisible(element)"
                (click)="action.handler(element)"
              >
                {{ action.label }}
              </button>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <!-- Hàng tiêu đề -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
      <!-- Hàng dữ liệu -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="border: none !important;"></tr>

      <!-- Duyệt qua từng cột và tạo cột động
      <ng-container *ngFor="let column of columns" [matColumnDef]="column" style="background-color: white;">
        <th mat-header-cell *matHeaderCellDef> {{ column | titlecase }} </th>
        <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
      </ng-container> -->

     <!-- Cột action -->


      <!-- Hàng tiêu đề -->
      <!-- <tr mat-header-row *matHeaderRowDef="columns" class="header-row"></tr> -->
      <!-- Hàng dữ liệu -->
      <!-- <tr mat-row *matRowDef="let row; columns: columns;" style="border: none !important;"></tr> -->
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalItems"
    [pageIndex]="currentPageIndex" (page)="onPageChange($event)" [textContent]="" aria-label="Select page">
  </mat-paginator>

</div>
